import React from 'react';
import { motion } from 'framer-motion';
import { Coffee } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 overflow-hidden" data-id="element-100">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-101">
        <img src="https://cdn.magicpatterns.com/uploads/dh5hMG4eWpJzeTfBAZzZvK/IMG_9571.jpg" alt="HOPE Cafetería Storefront" className="w-full h-full object-cover object-center" data-id="element-102" />
        <div className="absolute inset-0 bg-gradient-to-r from-hope-cream/95 via-hope-cream/80 to-transparent" data-id="element-103"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10 w-full" data-id="element-104">
        <div className="max-w-2xl" data-id="element-105">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-106">
            <a href="#menu" className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-hope-mustard/20 text-hope-brown text-xs font-semibold tracking-wider uppercase mb-6 border border-hope-mustard/30" data-id="element-107">
            <Coffee size={14} className="text-hope-terracotta" data-id="element-108" />
            <span data-id="element-109">Menu</span>
          </a>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-5xl md:text-7xl font-serif font-bold text-hope-brown leading-tight mb-6" data-id="element-110">
            Coffee with a{' '}
            <span className="text-hope-terracotta italic" data-id="element-111">purpose.</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-hope-brown/80 mb-10 leading-relaxed max-w-xl" data-id="element-112">
            Located in Puerto Peñasco, Sonora. Every cup you enjoy helps fund
            the vital programs of Centro Comunitario Palabras de Esperanza.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-wrap gap-4" data-id="element-113">
            <a href="#menu" className="px-8 py-4 bg-hope-terracotta text-white rounded-full font-medium hover:bg-hope-terracotta/90 transition-colors shadow-lg shadow-hope-terracotta/20" data-id="element-114">
              View Menu
            </a>
            <a href="#community" className="px-8 py-4 bg-white text-hope-brown rounded-full font-medium hover:bg-hope-cream transition-colors border border-hope-mustard/30 shadow-soft" data-id="element-115">
              Our Mission
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}